import React from "react";
import { PageHeader } from "@/components/ui-blocks/PageHeader";
import { TeamGrid } from "@/components/sections/TeamGrid";

export default function TeamPage() {
  return (
    <main>
      <PageHeader eyebrow="Our Team" title="Meet the people behind CAF." lead="Public-service professionals, doctors, technologists and finance leaders working full-time to deliver measurable civic impact." />
      <TeamGrid />
    </main>
  );
}
